import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import _ from "lodash";

import { Form, Select, Button, Radio } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { getGlobalMatchdays } from "../../../../../../services/backend/api.service";
import {
  CameraOutlined,
  CheckOutlined,
  DeleteOutlined,
  EditOutlined,
  InstagramOutlined,
  MenuOutlined,
  PlusCircleOutlined,
  ShareAltOutlined,
  VideoCameraAddOutlined,
  VideoCameraOutlined,
  ZoomInOutlined,
  PlayCircleOutlined,
  AimOutlined,
} from "@ant-design/icons";
const { Option } = Select;

export const InputSelect = (props) => {
  const { item, feedType, onValuesChange } = props;

  function onChange(value) {
    console.log(`selected ${value}`);
  }

  function onBlur() {}

  function onFocus() {}

  function onSearch(val) {}

  const [items, setItems] = useState([]);

  useEffect(() => {
    if (feedType) {
      getGlobalMatchdays({ feedType: feedType })
        .then((data) => {
          const apiDataTeams = _.get(data, "data.teams", []);
          setItems(apiDataTeams);
        })
        .catch((err) => {
          console.error("err", err);
        });
    }
  }, [feedType]);

  const isClearable = item.id === "facts_country";
  return (
    <Form.Item
      label={item.label}
      name={`${item.id}`}
      rules={[{ required: false, message: "Please input your username!" }]}
      tooltip={props.tooltip}
    >
      <Select
        showSearch
        style={{ width: 200 }}
        placeholder={item.label}
        optionFilterProp="children"
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onSearch={onSearch}
        allowClear={isClearable}
        onClear={() => {
          if (isClearable) {
            onValuesChange({ facts_country: "" });
          }
        }}
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        {...props}
      >
        {_.map(
          feedType === "heimspiel" ? items : item.selectData,
          (_item, itemIndex) => {
            const key = feedType === "heimspiel" ? _item.id : _item.value;
            const label = feedType === "heimspiel" ? _item.name : _item.label;
            return (
              <Option key={"s" + key} value={key}>
                {label}
              </Option>
            );
          },
        )}
      </Select>
    </Form.Item>
  );
};
